import { GetPaymentTotalsDocument, GetPaymentTotalsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type PayrollPaymentTotal =
  GetPaymentTotalsQuery['payroll']['paymentTotalsConnection']['nodes'][number]
export const usePaymentTotals = (currentPolicyPeriodId: string) => {
  const { data, error, refetch, loading } = useQuery(GetPaymentTotalsDocument, {
    variables: {
      policyPeriodId: currentPolicyPeriodId,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  })

  const totals = data?.payroll.paymentTotalsConnection.nodes ?? []
  return {
    totals,
    error,
    refetch,
    loading,
  }
}
